import { render, staticRenderFns } from "./RenderCopy.vue?vue&type=template&id=1d14b4ca"
import script from "./RenderCopy.vue?vue&type=script&lang=ts"
export * from "./RenderCopy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports